module.exports = __webpack_public_path__ + "static/img/preview-02.0db57e20.webp";